var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapMarkerAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97229 26.4553C1.40469 15.3473 0 14.2073 0 10.125C0 4.5331 4.47714 0 10 0C15.5229 0 20 4.5331 20 10.125C20 14.2073 18.5953 15.3473 11.0277 26.4553C10.5311 27.1816 9.46885 27.1816 8.97229 26.4553ZM10 14.3438C12.3012 14.3438 14.1667 12.455 14.1667 10.125C14.1667 7.79504 12.3012 5.90625 10 5.90625C7.6988 5.90625 5.83333 7.79504 5.83333 10.125C5.83333 12.455 7.6988 14.3438 10 14.3438Z",
    fill: "#E45D23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 27,
    fill: "white"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyMCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik04Ljk3MjI5IDI2LjQ1NTNDMS40MDQ2OSAxNS4zNDczIDAgMTQuMjA3MyAwIDEwLjEyNUMwIDQuNTMzMSA0LjQ3NzE0IDAgMTAgMEMxNS41MjI5IDAgMjAgNC41MzMxIDIwIDEwLjEyNUMyMCAxNC4yMDczIDE4LjU5NTMgMTUuMzQ3MyAxMS4wMjc3IDI2LjQ1NTNDMTAuNTMxMSAyNy4xODE2IDkuNDY4ODUgMjcuMTgxNiA4Ljk3MjI5IDI2LjQ1NTNaTTEwIDE0LjM0MzhDMTIuMzAxMiAxNC4zNDM4IDE0LjE2NjcgMTIuNDU1IDE0LjE2NjcgMTAuMTI1QzE0LjE2NjcgNy43OTUwNCAxMi4zMDEyIDUuOTA2MjUgMTAgNS45MDYyNUM3LjY5ODggNS45MDYyNSA1LjgzMzMzIDcuNzk1MDQgNS44MzMzMyAxMC4xMjVDNS44MzMzMyAxMi40NTUgNy42OTg4IDE0LjM0MzggMTAgMTQuMzQzOFoiIGZpbGw9IiNFNDVEMjMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyNyIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgMapMarkerAltSolid as ReactComponent };